import React from "react";
import {connect} from "react-redux";

class Filters extends React.Component {
    state={
        data:{
            "sortBy": "None",
            "bookType": "None",
            "bookList": "None",
            "dateCreatedOn": "yyyy-MM-dd"
        }
    };
    onchange = event => {
        this.setState({change:true,
            data: {...this.state.data, [event.target.name] : event.target.value }
        });
        // if(event.target.value === "Date Created"){
        // // this.props.sortLast();}
        // if(event.target.value === "None"){
        // this.props.sortNone();}
        // if(event.target.value === "RecView"){
        // this.props.RecView();}
        // if(event.target.name === "dateCreatedOn"){
        // this.props.dateCreatedOn(event.target.value);}
        // if(event.target.name === "bookType"){
        // this.props.bookType(event.target.value);}
    };
    clear = e=>{
        this.props.clear();
        this.setState({
            data:{
                "sortBy": "None",
                "bookType": "None",
                "bookList": "None",
                "dateCreatedOn": "yyyy-MM-dd"
            },
            change: false
        })
    };
    apply = e => {
        this.props.apply(this.state.data);
        // if(event.target.value === "RecView"){
        // this.props.RecView();}
        // if(event.target.name === "dateCreatedOn"){
        // this.props.dateCreatedOn(event.target.value);}
        // if(event.target.name === "bookType"){
        // this.props.bookType(event.target.value);}
    };
    render(){
        const {sortBy, bookType, bookList, dateCreatedOn} = this.state.data;
        return(
            <div className="filters">
                <div className="db">
                    <h5>You can Apply filters to change</h5>
                    <div id="sortBy">
                        <label> Sort By: </label>
                        <div></div>
                        <select onChange={this.onchange} value={sortBy} name="sortBy">
                            <option value="None"> None </option>
                            <option value="Date Created"> Date Created </option>
                            <option value="RecView"> Recently Viewed </option>
                        </select>
                    </div>
                    <h3>Filters</h3>
                    <div id="bookType">
                        <label> Book Type: </label>
                        <div></div>
                        <select onChange={this.onchange} value={bookType} name="bookType">
                            <option value="None"> None </option>
                            <option value="PDF"> PDF </option>
                            <option value="HTML"> HTML </option>
                        </select>
                    </div>
                    <div id="bookList">
                        <label> In the Book List: </label>
                        <div></div>
                        <select onChange={this.onchange} value={bookList} name="bookList">
                            <option value="None"> None </option>
                            <option value="Date Created"> Computer Science </option>
                            <option value="My Books"> Class 4 </option>
                        </select>
                    </div>
                    <div id="dateCreatedOn">
                        <label> Date Created On: </label><br/>
                        <input type="date" onChange={this.onchange} value={dateCreatedOn} name="dateCreatedOn"/>
                    </div>
                    <div className="jsb">
                        <button className="btn btn-danger resb" onClick={this.clear}>Clear</button>
                        <button className="btn btn-primary resb" onClick={this.apply}>Apply</button>
                    </div>
                </div>
            </div>
        );
    }
};

function mapStateToProps(state){
    return {books: state.AllBooks.books}
}

export default connect(mapStateToProps, {})(Filters);